/**
 * Returns the sorted, deduplicated list of values at `key` across `items`,
 * dropping falsy values.
 * @param {Array<object>} items
 * @param {string} key
 * @returns {Array}
 */
export const uniqueSorted = (items, key) =>
    Array.from(new Set((items || []).map(item => item[key]).filter(Boolean))).sort();
